import { render, staticRenderFns } from "./Footnote.vue?vue&type=template&id=745a4fde&"
import script from "./Footnote.vue?vue&type=script&lang=js&"
export * from "./Footnote.vue?vue&type=script&lang=js&"
import style0 from "./Footnote.vue?vue&type=style&index=0&id=745a4fde&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports